/** Assume-role impersonation cookies + 403 helper. */

export const SV_IMP_COOKIE = "sv_imp";
export const SV_IMP_META_COOKIE = "sv_imp_meta";

export type ImpersonationMode = "shadow" | "assist";

export interface ImpersonationStatus {
  active: boolean;
  session_id?: string;
  mode?: ImpersonationMode;
  display_name?: string;
  expires_at?: string;
  seconds_left?: number;
}

export function isImpersonationReadOnly(detail: unknown): boolean {
  if (!detail) return false;
  if (typeof detail === "string") {
    return detail === "impersonation_read_only" || detail === "impersonation_money_path";
  }
  if (typeof detail === "object") {
    const record = detail as { code?: unknown; detail?: unknown };
    if (typeof record.code === "string") {
      return (
        record.code === "impersonation_read_only" ||
        record.code === "impersonation_money_path"
      );
    }
    if (record.detail) return isImpersonationReadOnly(record.detail);
  }
  return false;
}

export const IMPERSONATION_TOAST =
  "You're viewing as a member — actions are disabled";
